// extracted by mini-css-extract-plugin
export default {"body":"login_body__rsk6l","login":"login_login__9Gx2p","logo":"login_logo__ZFVH0","welcome_back":"login_welcome_back__LyPs8","top_text":"login_top_text__K8iwI"};